<template>
	<div class="bdinfo">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys" ></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">查看店主</div>
					<div class="contentcard" style="margin-bottom: 0px;padding-bottom: 70px;">
						<div style="display: flow-root;position: relative;">
							<a-input-search placeholder="搜索店主" style="width: 200px;float: right;margin: -10px 0 10px 0;" @search="onSearchShopkeeper" />
						</div>
						<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
							<a-col :span="4" style="text-align: center;">店铺名称</a-col>
							<a-col :span="3" style="text-align: center;">联系电话</a-col>
							<a-col :span="6" style="text-align: center;">店铺地址</a-col>
							<a-col :span="6" style="text-align: center;">操作</a-col>
						</a-row>
						<div v-if="issearch" style="text-align: center;border-radius: 4px;padding: 11px 0 0 0;">
							<a-spin />
						</div>
						<div v-if="(!shopkeeperlist.length)&&(!issearch)">
							<a-alert message="查询结果为空" banner type="info" />
						</div>
						<div style="color: #666;font-size: 14px;" v-for="(shopkeeper,index) in shopkeeperlist" :key="index">
							<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;border-top: none;min-height: 60px;padding: 5px 0;">
								<a-col :span="4" style="text-align: center;" v-if="shopkeeper.UIC_User_Licenses.length>0">{{shopkeeper.UIC_User_Licenses[0].name}}</a-col>
								<a-col :span="3" style="text-align: center;" v-if="shopkeeper.UIC_User_Licenses.length>0">{{shopkeeper.phone_number}}</a-col>
								<a-col :span="6" style="text-align: center;" v-if="shopkeeper.UIC_User_Licenses.length>0">{{shopkeeper.UIC_User_Licenses[0].province+shopkeeper.UIC_User_Licenses[0].city+shopkeeper.UIC_User_Licenses[0].district+shopkeeper.UIC_User_Licenses[0].street}}</a-col>
								<a-col :span="4" style="text-align: center;" v-if="shopkeeper.UIC_User_Licenses.length==0">该店主暂未上传营业执照,请联系店主尽快上传</a-col>
								<a-col :span="3" style="text-align: center;" v-if="shopkeeper.UIC_User_Licenses.length==0">{{shopkeeper.phone_number}}</a-col>
								<a-col :span="6" style="text-align: center;" v-if="shopkeeper.UIC_User_Licenses.length==0">暂无</a-col>
								<a-col :span="6" style="text-align: center;">
									<a-button-group>
									      <a-button size="small" type="link" :disabled="shopkeeper.UIC_User_Licenses.length==0" @click="lookphoto(shopkeeper.UIC_User_Licenses[0])">查看营业执照</a-button>|
									      <a-button size="small" type="link" @click="gototrade(shopkeeper)">查看订单</a-button>|
										  <a-button size="small" type="link" disabled>删除</a-button>
									    </a-button-group>
								</a-col>
							</a-row>
						</div>
						<div style="float: right;position: relative;bottom: -18px;">
							<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize" :total="shopkeepersum"
							 showQuickJumper @change="pageChange" />
						</div>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>
		
		<a-modal title="营业执照" :visible="photo_visible" :width="1200" @cancel="photo_Cancel" :footer="null">
			<div style="text-align: center;">
				<img :src="photo_info" height="500px">
			</div>
		</a-modal>
		
	</div>
</template>

<script>
	export default {

		data() {
			return {
				current: ['bdmanagement'],
				openKeys: ['bdmodule'],
				bd_id:this.$route.query.bd_id,
				startpage: this.$route.query.startpage || 0,
				endpage: this.$route.query.endpage || 10,
				pageSize: Number(this.$route.query.pageSize) || 10,
				searchvalue:null,
				shopkeeperlist:[],
				issearch:false,
				shopkeepersum: 0,
				photo_info:null,
				photo_visible:false,
			}
		},
		created: function() {
			this.initialize();
		},
		methods: {
			initialize(){
				var self = this;
				this.issearch = true;
				this.shopkeeperlist = [];
				this.shopkeepersum = 0;
				var params = {
					searchvalue: this.searchvalue,
					startpage: this.startpage,
					pageSize: this.pageSize,
					bd_id:this.bd_id
				};
				this.$axios.get('/bd/getshopkeeperlist', {
					params: params
				}).then(function(res) {
					self.shopkeeperlist = res.data.shopkeeperlist;
					self.shopkeepersum = res.data.shopkeepersum;
					self.issearch = false;
				});
			},
			onShowSizeChange(current, pageSize) {
				this.pageSize = pageSize;
				this.startpage = this.pageSize * (current - 1);
				this.endpage = this.pageSize * current;
				this.initialize();
				this.$router.push({
					name: 'bdinfo',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchvalue:this.searchvalue,
						bd_id:this.bd_id
					}
				})
			
			},
			pageChange(pageNumber) {
				this.startpage = this.pageSize * (pageNumber - 1);
				this.endpage = this.pageSize * pageNumber;
				this.initialize();
				this.$router.push({
					name: 'bdinfo',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchvalue:this.searchvalue,
						bd_id:this.bd_id
					}
				})
			},
			onSearchShopkeeper(value){
				var self = this;
				this.searchvalue = value;
				this.startpage = 0;
				this.endpage = this.pageSize;
				// this.pageSize = 10;
				this.initialize();
				this.$router.push({
					name: 'bdinfo',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchvalue:this.searchvalue,
						bd_id:this.bd_id
					}
				})
			},
			lookphoto(photo){
				// console.log(photo);
				this.photo_info = photo.license_img;
				this.photo_visible = true;
			},
			photo_Cancel(){
				this.photo_info =null;
				this.photo_visible = false;
			},
			gototrade(shopkeeper){
				this.$router.push({
					name: 'bdtrade',
					query: {
						shopkeeper_id: shopkeeper.id,
					}
				})
			},
		}

	};
</script>

<style>

	.bdinfo .contentcard {
		padding: 24px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}
</style>




// WEBPACK FOOTER //
// index.vue?d0d88f14